import type { RouteObject } from "react-router-dom";
import { productKnowledgeRoutes } from "./product-knowledge/route";

export const askRedoRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Ask Redo" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => false} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { EnhancedAnalyticsPage } = await import(
            "./enhanced-analytics-page"
          );
          return { Component: EnhancedAnalyticsPage };
        },
      },
      { path: "product-knowledge", children: productKnowledgeRoutes },
    ],
  },
];
